import { Layout, ApValue as ApValueComponent } from "components"
export const ApValue = () => {
 return (
  <Layout>
   <ApValueComponent />
  </Layout>
 )
}
